module.exports = __webpack_public_path__ + "static/media/gestioneRichiesteServizi.c8e2b2c4.png";